var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMagnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 95,
    viewBox: "0 0 273 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273 0H0V95H273V0Z",
    fill: "#E30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.929 60.7872V34.2899H161.031V40.4392H151.056V60.7872H143.929Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.556 60.7872V50.4142H171.964V60.7872H164.837V34.2899H171.964V44.1751H182.556V34.2899H189.696V60.7872H182.556Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.758 34.2899V40.4392H231.092V60.7872H238.232V40.4392H246.606V34.2899H222.758Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.257 60.7872V45.6899L200.904 60.7872H194.946V34.2899H202.086V49.2332L213.242 34.2899H219.397V60.7872H212.257Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.939 60.7872V45.0352L95.8125 53.3541L88.6988 45.0352V60.7872H81.5587V34.2899H88.5937L95.8125 43.4048L103.031 34.2899H110.066V60.7872H102.939Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.611 51.4669H130.174L126.866 43.1609L123.611 51.4669ZM133.954 60.7872L132.471 57.0771H121.38L119.897 60.7872H112.704L123.69 34.2899H130.252L141.225 60.7872H133.954Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3288 39.6689C26.3357 36.4682 27.6396 33.4008 29.9546 31.1388C32.2697 28.8768 35.4071 27.6047 38.6794 27.6013H67.1869V33.7378H38.6794C37.071 33.7412 35.5293 34.3667 34.3908 35.4779C33.2523 36.5891 32.6094 38.0957 32.6025 39.6689V49.9392C32.4727 51.2589 31.9003 52.4995 30.9744 53.4678C30.0486 54.4361 28.8213 55.0777 27.4838 55.2925L26.3681 55.4594L26.3288 39.6689Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3288 67.4756V61.3391H54.8363C56.4446 61.3358 57.9863 60.7102 59.1248 59.599C60.2633 58.4878 60.9062 56.9812 60.9131 55.4081V45.6256C60.9351 44.216 61.4642 42.859 62.4075 41.7931C63.3509 40.7271 64.6481 40.0205 66.0713 39.7972L67.1869 39.6432V55.4081C67.1799 58.6087 65.8761 61.6761 63.561 63.9381C61.2459 66.2002 58.1085 67.4722 54.8363 67.4756H26.3288Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4788 55.5108V47.5771L46.7513 51.9291L43.0369 47.5771V55.5108H38.115V39.9H42.7875L46.7513 44.9196L50.7281 39.9H55.3875V55.5108H50.4788Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMagnit);
export default __webpack_public_path__ + "upload/logo-magnit.f34da207db5655d62d5f74cdcd95d88d.svg";
export { ForwardRef as ReactComponent };